export class User {
  // tslint:disable-next-line: variable-name
  _id?: string;
  email?: string;
  role?: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  isCorporate?: boolean;
  status?: string;
  profilePic?: string;
  acceptTNC?: boolean;
  acceptPP?: boolean;
  onboard?: boolean;
  organization?: {
    name?: string;
    industry?: string;
    size?: string;
    website?: string;
    role?: string;
  };
  rzCustomerId?: string;
  rzPlanId?: string;
  rzSubscriptionId?: string;
  isTeamAdmin?: boolean;
  teamSize?: string;
}
